export const REGISTER_REQUESTING = 'REGISTER_REQUESTING';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const REGISTER_INIT = 'REGISTER_INIT';
